import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonCol, IonLabel, IonRow } from '@ionic/angular/standalone';

@Component({
  selector: 'app-info-pill',
  templateUrl: './info-pill.component.html',
  styleUrls: ['./info-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonLabel, IonRow, IonCol]
})
export class InfoPillComponent {
  @Input() headerLabel: string;
  @Input() leftIcon: string;
  @Input() rightIcon: string;
  @Input() leftImageSrc: string;
  @Input() rightImageSrc: string;
  @Input() leftText: string;
  @Input() rightText: string;
  @Input() leftTextLineOne: string;
  @Input() leftTextLineTwo: string;
  @Input() rightTextLineOne: string;
  @Input() rightTextLineTwo: string;
}
